import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const styles = (theme) => ({
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    padding: 24,
    position: "sticky",
    bottom : 0,
    backgroundColor: theme.gridBGColor,
    zIndex: 1
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    padding: 24,
    backgroundColor: theme.gridBGColor,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    position: "sticky",
    bottom : 0,
    zIndex: 1
  },
  submitButton: {
    marginLeft: 16,
  },
});

const FooterWithPrevious = (props) => {
  const {
    classes,
    handleClose,
    confirmButtonText,
    handleSubmit,
    isDisabled=false,
    handlePrevious,
  } = props;
  return (
    <div className={classes.container}>
      <Button autoFocus onClick={handlePrevious} color="primary" variant="outlined">
        Previous
      </Button>
      <div className={classes.footer}>
        <Button autoFocus onClick={handleClose} color="primary" variant="outlined">
          Close
        </Button>
        <Button
          autoFocus
          disabled={isDisabled}
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          className={classes.submitButton}
        >
          {confirmButtonText}
        </Button>
      </div>
    </div>
  )
}

const FooterWithoutPrevious = (props) => {
  const {
    classes,
    handleClose,
    confirmButtonText,
    handleSubmit,
    isDisabled=false,
  } = props;
  return (
    <div className={classes.dialogFooter}>
      <Button autoFocus onClick={handleClose} color="primary" variant="outlined">
        Close
      </Button>
      <Button
        autoFocus
        disabled={isDisabled}
        color="primary"
        variant="contained"
        onClick={handleSubmit}
        className={classes.submitButton}
      >
        {confirmButtonText}
      </Button>
    </div>
  )
}

const EditStopDialogAction = (props) => (
  props?.hasPrevious
    ? <FooterWithPrevious {...props}/>
    : <FooterWithoutPrevious {...props}/>
);

export default withStyles(styles)(EditStopDialogAction);
